import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router';
import { CommunityMemberRole } from '@api/ChallengeClient';
import { Button } from '@components/ui/button';
import { toast } from '@core/toast';
import { EmployeeContext } from '..';
import { FormSection } from '../../../components/form-section';
import { I18n } from '../../../core/i18n';
import { injectTSDI } from '../../../core/tsdi';
import { Api } from '../../../core/api';
import { useError } from '../../../components/hooks/useError';

export default observer(() => {
    const employee = React.useContext(EmployeeContext);
    const { tenantName } = useParams();
    const { formatLongDate } = injectTSDI(I18n);
    const { challengeClient } = injectTSDI(Api);

    const showError = useError();

    const setAsManager = useCallback(async () => {
        try {
            await challengeClient.support.communitySupportControllerSetRole(
                tenantName,
                employee.mySportsId!,
                { role: CommunityMemberRole.MANAGER }
            );
            toast.success('User successfully set as manager');
        } catch (e: any) {
            if (e.status === 404) {
                toast.error('Community or member not exist');
            } else {
                showError(e);
            }
        }
    }, [tenantName, employee.mySportsId, showError]);

    return (
        <FormSection
            title="Employee"
            actions={
                <Button onClick={() => void setAsManager()}>
                    Set as Community Manager
                </Button>
            }
        >
            <dl className="grid grid-cols-[160px_1fr] gap-y-2 text-sm">
                <dt className="text-muted-foreground">Name</dt>
                <dd>
                    {employee.firstName} {employee.lastName}
                </dd>
                <dt className="text-muted-foreground">Email</dt>
                <dd className="truncate" title={employee.email}>
                    {employee.email}
                </dd>
                <dt className="text-muted-foreground">Date of birth</dt>
                <dd>{employee.dateOfBirth}</dd>
                <dt className="text-muted-foreground">MySports ID</dt>
                <dd>{employee.mySportsId}</dd>
                {employee.connectedDate && (
                    <>
                        <dt className="text-muted-foreground">
                            Connected Date
                        </dt>
                        <dd>{formatLongDate(employee.connectedDate)}</dd>
                    </>
                )}
            </dl>
        </FormSection>
    );
});
